import $ from "jquery";
import 'jquery-ui/ui/widgets/selectmenu';

export const formSelect = () => {
    const $selectable = $('.selectable');

    if ($selectable.length === 0) {
        return;
    }

    $selectable.selectmenu({
        position: {
            my: "left top",
            at: "left bottom"
        }
    });
};
